import { render, staticRenderFns } from "./collectOpportunitiesRecord.vue?vue&type=template&id=b07e8b66&scoped=true"
import script from "./collectOpportunitiesRecord.vue?vue&type=script&lang=js"
export * from "./collectOpportunitiesRecord.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b07e8b66",
  null
  
)

export default component.exports